import { render, staticRenderFns } from "./Formal.vue?vue&type=template&id=ad021804&scoped=true&lang=html&"
import script from "./Formal.vue?vue&type=script&lang=ts&"
export * from "./Formal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad021804",
  null
  
)

export default component.exports